export default __webpack_public_path__ + "static/media/division-5.fb1772ce.png";